<script lang="ts">
  // Rendered as an image so crawlers cannot harvest the address (regenerate with `vips text` when it changes).
  import addressImage from '../../../images/operator/address.png'
</script>

<img class="operator-address" src={addressImage} width="184" height="73" alt="" />

<style>
  .operator-address {
    display: block;
    margin: 0 0 var(--space-7);
  }
</style>
